import type { FormikProps } from 'formik'
import React from 'react'
import { Helmet } from 'react-helmet-async'
import type { SettingsResponse } from '../../interfaces'
import { NamedTransformsSettingsLayout } from '../../layouts/Settings'

const NamedTransformsSettingsPage = ({
  form,
  getData,
}: {
  form: FormikProps<SettingsResponse>
  getData(): Promise<void>
}): React.ReactElement => (
  <React.Fragment>
    <Helmet>
      <title>Named Transforms Settings</title>
      <meta name="description" content="Named Transforms Settings page" />
    </Helmet>
    <NamedTransformsSettingsLayout form={form} getData={getData} />
  </React.Fragment>
)

export default NamedTransformsSettingsPage
